/* esm.sh - applesauce-core@5.2.0/helpers/pointers */
export * from "/*applesauce-core@5.2.0/esnext/helpers/pointers.mjs";
